(function() {
    'use strict';
    Odigeo.UIElements.shake = {};
    Odigeo.UIElements.shake.enhance = function(wrapper, newOptions) {
        var $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
        var options = {
            delay: 0.01,
            initHidden: true,
        };
        var showShakeElement;
        var hideShakeElement;

        if ($wrapper.length === 0) {
            return false;
        }

        if ($wrapper.attr('data-skip-enhance') === 'true') {
            return $wrapper;
        }

        $wrapper.attr({'data-skip-enhance': true});
        options = Odigeo._.extend(options, newOptions);

        if (options.initHidden) {
            $wrapper.addClass('odf-hidden');
        }

        /**
         * Show the element that contains $wrapper
         */
        showShakeElement = function() {
            $wrapper.removeClass('odf-hidden open odf-shake');
            Odigeo._.delay(function() {
                $wrapper.addClass('open odf-shake');
            }, options.delay * 1000);
        };

        /**
         * Hide the element that contains $wrapper
         */
        hideShakeElement = function() {
            $wrapper.removeClass('open odf-shake');
        };

        $wrapper
            .on('showShakeElement', showShakeElement)
            .on('hideShakeElement', hideShakeElement);

        return $wrapper;
    };

    Odigeo.UIElements.shake.unbind = function($wrapper) {
        $wrapper.off('showShakeElement hideShakeElement');

        return $wrapper;
    };
})();
